import { render } from "./RpmButtonDynamicTag.vue?vue&type=template&id=b70522ca"
import script from "./RpmButtonDynamicTag.vue?vue&type=script&lang=js"
export * from "./RpmButtonDynamicTag.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__